import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getAllGMPUsersData = createApi(`GetAllGMPUsers`,"GET");

const GetAllGMPUsers = createSlice({
  name: 'GetAllGMPUsers',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllGMPUsersData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllGMPUsersData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllGMPUsersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAllGMPUsers.reducer;